export default "__VITE_ASSET__B12ZPCQT__"